import React from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import * as CONST from './Const';

const AddButton = ({ onExecute }) => (
	<div style={{ textAlign: 'left' }}>
		<Button color="primary" onClick={onExecute} title={CONST.ADD_BUTTON_TOOLTIP}>
			New
		</Button>
	</div>
);

const EditButton = ({ onExecute }) => (
	<IconButton onClick={onExecute} title={CONST.EDIT_BUTTON_TOOLTIP}>
		<EditIcon />
	</IconButton>
);

const DeleteButton = ({ onExecute }) => (
	<IconButton
		onClick={() => {
			// eslint-disable-next-line
			if (window.confirm(CONST.WINDOW_CONFIRM_DELETE)) {
				onExecute();
			}
		}}
		title={CONST.DELETE_BUTTON_TOOLTIP}
	>
		<DeleteIcon />
	</IconButton>
);

const CommitButton = ({ onExecute }) => (
	<IconButton onClick={onExecute} title={CONST.COMMIT_BUTTON_TOOLTIP}>
		<SaveIcon />
	</IconButton>
);

const CancelButton = ({ onExecute }) => (
	<IconButton className="margin-left-medium" color="secondary" onClick={onExecute} title={CONST.CANCEL_BUTTON_TOOLTIP}>
		<CancelIcon />
	</IconButton>
);

const commandComponents = {
	add: AddButton,
	edit: EditButton,
	delete: DeleteButton,
	commit: CommitButton,
	cancel: CancelButton,
};

const Command = ({ id, onExecute }) => {
	const CommandButton = commandComponents[id];
	return <CommandButton onExecute={onExecute} />;
};

export default Command;
